<template>
    <div class="uptop" id="uptop">
        <img src="../assets/images/icon/totop.png" @click="clickToTop" id="to-top">
    </div>
</template>

<script>
    export default {
        props:{

        },
        data:()=>{
            return{
                timer:''
            }
        },
        computed: {
        },
        mounted(){
            this.addEvent()
        },
        methods:{
            clickToTop(){
                var self = this;
                this.timer=setInterval(function(){ //设置一个计时器
                    var ct = document.documentElement.scrollTop || document.body.scrollTop; //获取距离顶部的距离
                    ct-=10;
                    if(ct>0){//如果与顶部的距离大于零
                        window.scrollTo(0,ct);//向上移动10px
                    }
                    else{//如果距离小于等于零
                        window.scrollTo(0,0);//移动到顶部
                        clearInterval(self.timer);//清除计时器
                    }
                },10);//隔10ms执行一次前面的function，展现一种平滑滑动效果
            },
            addEvent(){
                window.onscroll = function(){
                    var t = document.documentElement.scrollTop || document.body.scrollTop;  //获取距离页面顶部的距离
                    var uptop = document.getElementById( "uptop" ); //获取div元素
                    if( t >= 400 ) { //当距离顶部超过300px时
                        uptop.style.opacity= 1;
                    } else { //如果距离顶部小于300px
                        uptop.style.opacity= 0;
                    }
                }
                this.timer=null;
            }
        }
    }
</script>

<style scoped lang="scss">
    #uptop{
        position:fixed;//位置固定
        bottom:200px;//距离底部-50px，为了使一开始不显示
        right:30px;//距离右边10px
        background-color: #efefef;
        border-radius: 50%;
        padding-top: 10px;
        width: 50px;
        height: 50px;
        z-index:99;//为了使此部分位于整个页面的最上部分，不会被覆盖
        -webkit-transition:all .5s;//设置改变bottom时的动画效果
        -moz-transition:all .5s;
        -ms-transition:all .5s;
        -o-transition:all .5s;
        transition:all .5s;
    }
    #to-top{
        width:60%;
        cursor:pointer;
        vertical-align: baseline;
    }
</style>